import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router, ActivatedRoute} from '@angular/router';

// import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';

import { enableRipple } from '@syncfusion/ej2-base';
// enable ripple effects
enableRipple(true);
import { DataManager, ODataAdaptor, WebApiAdaptor, UrlAdaptor,Query, ReturnOption, DataUtil  } from '@syncfusion/ej2-data';
import { MenuItemModel } from '@syncfusion/ej2-angular-navigations';
import { PageSettingsModel, FilterSettingsModel } from '@syncfusion/ej2-grids';

import { ChangeEventArgs } from '@syncfusion/ej2-inputs';
import { createElement } from '@syncfusion/ej2-base';
import {  IFilter, RowSelectEventArgs, SelectionSettingsModel, TextWrapSettingsModel } from '@syncfusion/ej2-angular-grids';
import { GridComponent, ToolbarItems, ToolbarService, ExcelExportService, GroupSettingsModel,
RowDataBoundEventArgs  } from '@syncfusion/ej2-angular-grids';
import { ClickEventArgs } from '@syncfusion/ej2-angular-navigations';


import { FilterService, IFilterUI, Column } from '@syncfusion/ej2-angular-grids';
import { DatePicker } from '@syncfusion/ej2-calendars';
import { parentsUntil } from '@syncfusion/ej2-grids';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { delay, map, Observable, retry } from 'rxjs';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { MyobApiInvoiceSyncToolsWidgetComponent } from 'src/app/components/myob/myob-api-invoice-sync-tools-widget/myob-api-invoice-sync-tools-widget.component';
import { MyobApiPurchaseSyncToolsWidgetComponent } from 'src/app/components/myob/myob-api-purchase-sync-tools-widget/myob-api-purchase-sync-tools-widget.component';
import { BsModalService } from 'ngx-bootstrap';
import { MyobApiInvoicePaymentSyncToolsWidgetComponent } from 'src/app/components/myob/myob-api-invoice-payment-sync-tools-widget/myob-api-invoice-payment-sync-tools-widget.component';



const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};


@Component({
  selector: 'app-myob-daily-tasks',
  templateUrl: './myob-daily-tasks.component.html',
  styleUrls: ['./myob-daily-tasks.component.scss']
})
export class MyobDailyTasksComponent implements OnInit, AfterViewInit, OnDestroy {
 


  @Input() sent_data?: any; // not used

  @Input() response_from_node: string;
  @Input() response_from_node_raw: any;

  // Grid Vars
  public data: DataManager;
  public data_subjects: DataManager;
  public pageSettings: Object;
  public pageOptions = { pageSize: 25 }; 
  public filterOptions: FilterSettingsModel;
  public formatOptions: Object;
  // public filterOptions: FilterSettingsModel;
  public filter : IFilter;
  public toolbarOptions: ToolbarItems[];
  @ViewChild('grid')
  public grid: GridComponent;
  @ViewChild('comparitor_grid')
  public comparitor_grid: GridComponent;
  
  
  public groupOptions: GroupSettingsModel;
  public templateOptionsDate: IFilterUI;
  public elem1: HTMLElement;
  public datePickerObj: DatePicker;
  //checkbox selection options
  public selectionOptions: SelectionSettingsModel;
  public selIndex: number[] = [];
  subjects_urgent: any;
  formatoptions: { type: string; format: string; };
  dateFormat: string;
  sortOptions: { columns: { field: string; direction: string; }[]; };

  // public wrapSettings: { wrapMode: 'Content' | 'Both' | 'Header' }; // this allows the content to wrap only Header|Content|Both
  public wrapSettings: TextWrapSettingsModel; // this allows the content to wrap only Header|Content|Both

      // TABS sets the selected
      @ViewChild('staticTabs') staticTabs: TabsetComponent;
      
      // today = new Date().toISOString(); // this date worked to compare dates with ZISo date format in database.
      // today_name_file = this.datepipe.transform(this.today, 'dd-MM-yyyy-hhmmss'); // formats date for comparison
      // action_day = this.datepipe.transform(this.today, 'ddMMyyyy'); // formats date for comparison
      // action_day_words = this.datepipe.transform(this.today, 'EEEEMMMd-y'); // formats date for comparison


  today = new Date();
  initialPage: { pageSize: number; };
  open_jobs_count: any;
  myobCustomers: Object;
  arrCase: object[];
  Items: any;
  myobCustomerCreatedData: any;
  brand_types: any;
  users: any;
  usersPrimary: any;
  job_table_clients: any;
  btLocalRecord: any;
  changeObject: any;
  userLocalRecord: any;
  job_table_clients3: any;
  UID_new_customer: any;
  returned_update: Object;
  myobCustomerDeleteData: Object;
  myobCustomerUpdateData: Object;
  customerItem: any;
  myobContactListMapped: any;
  myobCustomer: Object;
  set_RowVersion: any;
  IsIndividual: any;
  sessionUserId: any;
  sessionUsername: any;
  sessionBrandId: any;
  all_router_details: string;
  difference_results: any[];
  comparitor_array: any[];
  baseMyobCustomers: any;
  search_results: any = [];
  selectedrecords: object[];
  Items2: any;
  comparitor_array_B: any;
  comparitor_array_A: any;
  myobInvoices: Object;
  invoices: any;
  comparitor_array_B_FULL: any; //?[]
  comparitor_array_A_FULL: any;
  pending_clients: any;
  count_pending_clients: any;
  pending_agents: any;
  count_pending_agents: any;
  pending_clients_invoices: any;
  count_pending_clients_invoices: any;
  pending_agents_invoices: any;
  count_pending_agents_invoices: any;
  pending_clients_invoices_payments: any;
  count_pending_clients_invoices_payments: any;
  pending_agents_invoices_payments: any;
  count_pending_agents_invoices_payments: any;
  interval
  post_new_approved_customers_result: Object;

  error_message: string;
  error_name: string;
  full_response_data: string;
  data_sent: string;
  data_sent_id: any;
  full_response_status: any;
  full_response_headers: any;
  full_response: any;
  data_sent_DisplayID: any;
  error_message_standard: any;
  data_sent_brand_id: any;
  data_sent_client_brand_id: any;
  data_sent_agent_brand_id: any;
  post_new_approved_customers_invoices_result: Object;
  data_sent_invoice_id: any;
  post_new_approved_supplier_invoices_result: Object;
  data_sent_agent_invoice_id: any;
  post_new_approved_customer_invoice_payments_result: Object;
  data_sent_invoice_payment_id: any;
  data_sent_supplier_invoice_payment_id: any;
  post_new_approved_supplier_invoice_payments_result: Object;

  // Directly to the child component. -- Maybe had to be included in the template or not.. that is what I am testing,.
  @ViewChild(MyobApiInvoiceSyncToolsWidgetComponent) childReference: any;
  @ViewChild(MyobApiPurchaseSyncToolsWidgetComponent) childReference_agent: any;
  @Input() test_message: any;
  data_sent_invoice_UID: any;
  data_sent_client_invoice_id: any;
  data_sent_work_order_payment_id: any;
  data_sent_work_order_id: any;
  data_sent_agent_work_order_id: any;
  data_sent_work_order_UID: any;
  data_sent_work_order_spending_id: any;
  workOrderItem: Object;
  job_notes_removed: number;
  subject_number: any;
  job_number: any;
  job_id: any;
  subject_id: any;
  work_order_id: any;
  work_order_number: any;
  work_order_total: any;
  invoice_model: any;
  invoiceItem: any;
  work_order_payment_status: any;
  invoice_number: any;
  invoice_total: any;
  invoice_payment_status: any;
  invoice_id: any;
  myob_checker: Object;
  myob_response: boolean;
  modalRef: any;

  // Tab changer daily tasks
  @Output('tabBelow') tabBelow: EventEmitter<any> = new EventEmitter();
  isShowSpinnerClients: number;
  isShowSpinnerClientsSync: number;
  isShowSpinnerAgents: number;
  isShowSpinnerAgentsSync: number;
  isShowSpinnerClientsInvoices: number;
  isShowSpinnerClientsInvoicesSync: number;
  isShowSpinnerAgentsInvoices: number;
  isShowSpinnerAgentsInvoicesSync: number;
  isShowSpinnerClientsInvoicesPayments: number;
  isShowSpinnerClientsInvoicesPaymentsSync: number;
  isShowSpinnerAgentsInvoicesPayments: number;
  isShowSpinnerAgentsInvoicesPaymentsSync: number;
  invoice_deleted_data: Object;
  invoice_update_payment_model;
  work_prder_deleted_data: Object;
  work_order_update_payment_model;
  set_max_sync_number: number;
  estimated_time_clientsinvoices: string;



  constructor(
    private http: HttpClient, private router: Router,
    private route: ActivatedRoute, private _demoService: DemoService,
   public datepipe: DatePipe,  public gfunc: GlobalFunctionsService,
   public toastr: HotToastService,
   vcr: ViewContainerRef,
   // myob clientInvoiceTools
   public clientInvoiceTools: MyobApiInvoiceSyncToolsWidgetComponent,
   public agentInvoiceTools: MyobApiPurchaseSyncToolsWidgetComponent,
   public myobApi_IPTW: MyobApiInvoicePaymentSyncToolsWidgetComponent,
   public myobApi_ITW: MyobApiInvoiceSyncToolsWidgetComponent,
   private modalService: BsModalService,
  ) { 
    this.wrapSettings = { wrapMode: 'Content' }; // this allows the content to wrap only Header|Content|Both

    this.isShowSpinnerClients = 0;
    this.isShowSpinnerClientsSync = 0;
    this.isShowSpinnerAgents = 0;
    this.isShowSpinnerAgentsSync = 0;
    this.isShowSpinnerClientsInvoices = 0;
    this.isShowSpinnerClientsInvoicesSync = 0;
    this.isShowSpinnerAgentsInvoices = 0;
    this.isShowSpinnerAgentsInvoicesSync = 0;
    this.isShowSpinnerClientsInvoicesPayments = 0;
    this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
    this.isShowSpinnerAgentsInvoicesPayments = 0;
    this.isShowSpinnerAgentsInvoicesPaymentsSync = 0;

    this.set_max_sync_number = 20; 
  }

  ngOnInit(): void {
            this.getPendingClients();
            this.getPendingClientsInvoices();
            this.getPendingClientsInvoicesPayments();
            this.getPendingAgents();
            this.getPendingAgentsInvoices();
            this.getPendingAgentsInvoicesPayments();
    
    // // Runs Every Five Seconds. or so
    // this.interval = setInterval(() => { 
    //   this.getPendingClients(); 
    //   this.getPendingClientsInvoices();
    //   this.getPendingClientsInvoicesPayments();
    //   this.getPendingAgents();
    //   this.getPendingAgentsInvoices();
    //   this.getPendingAgentsInvoicesPayments();
    //  }, 25000); // was 10000



  }

// Runs to load the child variables for errors. after load.
// dont forget to include this in to reference the child 
//   @ViewChild(MyobApiInvoiceSyncToolsWidgetComponent) childReference: any; // must be setup as a variable above.

  ngAfterViewInit(){
  // this.response_from_node = this.childReference.response_from_node;
  // this.test_message = this.childReference.test_message;

  this.StartRunIntervalFuntions()



}

// testing stop the interval loading in other routes once this route has been loaded once. 10/2/24
ngOnDestroy() {
  // this.interval.unsubscribe();

  // this.toastr.info("Clearing intervals: MYOB SYNC")
  // ::@https://www.tutorialrepublic.com/faq/how-to-stop-setinterval-call-in-javascript.php -- This worked and stopped interval
  clearInterval(this.interval);

}

  // @ https://betterprogramming.pub/angular-7-share-component-data-with-other-components-1b91d6f0b93f
  // To Get the Reference From the Child Module afterView Init... because the module must be loaded first.


// Need to get the figures from the same functions that do the initial counts to sync the data

// Starts the timer running
StartRunIntervalFuntions(){
    // Runs Every Five Seconds. or so
                // this.interval = setInterval(() => { 
                //   this.getPendingClients(); 
                //   this.getPendingClientsInvoices();
                //   this.getPendingClientsInvoicesPayments();
                //   this.getPendingAgents();
                //   this.getPendingAgentsInvoices();
                //   this.getPendingAgentsInvoicesPayments();
                //  }, 38000); // was 10000
}

// Clears and Stops the timer interval runnint
StopRunIntervalFuntions(){
  clearInterval(this.interval);
}



clearErrorResponses(){
  this.response_from_node = ''; // clear errors
  this.response_from_node_raw = ''; // clear errors
}

clearErrorResponsesAndRefresh(){
  clearInterval(this.interval);
  this.response_from_node = ''; // clear errors
  this.response_from_node_raw = ''; // clear errors
  this.ngOnInit();
  this.StartRunIntervalFuntions();
}

 // File Nameing
 getPendingClients() {
  this.isShowSpinnerClients = 1;

  this._demoService.getPendingClients().subscribe(
     data => { this.pending_clients = data;
      let res = data[0];
      this.count_pending_clients = this.pending_clients.length;
      // this.toastr.info('..refeshed..')
  this.isShowSpinnerClients = 0;

    },
     err => (console.error(err),
  this.isShowSpinnerClients = 0
     
     ),
     // () => console.log('done loading Trace Types')
   );
 }


 getPendingAgents() {
  this.isShowSpinnerAgents = 1;
  this._demoService.getPendingAgents().subscribe(
     data => { this.pending_agents = data;
      let res = data[0];
      this.count_pending_agents = this.pending_agents.length;
    this.isShowSpinnerAgents = 0;
    },
     err => (console.error(err),
    this.isShowSpinnerAgents = 0
     ),
     // () => console.log('done loading Trace Types')
   );
 }



 getPendingClientsInvoices() {
  this.isShowSpinnerClientsInvoices = 1;
  this._demoService.getPendingClientsInvoices().subscribe(
     data => { this.pending_clients_invoices = data;
      let res = data[0];
      this.count_pending_clients_invoices = this.pending_clients_invoices.length;
    this.isShowSpinnerClientsInvoices = 0;

    },
     err => (console.error(err),
    this.isShowSpinnerClientsInvoices = 0)
     // () => console.log('done loading Trace Types')
   );
 }


 getPendingAgentsInvoices() {
  this.isShowSpinnerAgentsInvoices = 1;

  this._demoService.getPendingAgentsInvoices().subscribe(
     data => { this.pending_agents_invoices = data;
      let res = data[0];
      this.count_pending_agents_invoices = this.pending_agents_invoices.length;
    this.isShowSpinnerAgentsInvoices = 0;

    },
     err => (console.error(err),
    this.isShowSpinnerAgentsInvoices = 0
     )
     // () => console.log('done loading Trace Types')
   );
 }


 getPendingClientsInvoicesPayments() {
  this.isShowSpinnerClientsInvoicesPayments = 1;
  this._demoService.getPendingClientsInvoicesPayments().subscribe(
     data => { this.pending_clients_invoices_payments = data;
      let res = data[0];
      this.count_pending_clients_invoices_payments = this.pending_clients_invoices_payments.length;
    this.isShowSpinnerClientsInvoicesPayments = 0;

    },
     err => (console.error(err),
    this.isShowSpinnerClientsInvoicesPayments = 0
     )
     // () => console.log('done loading Trace Types')
   );
 }


RemoveAllClientsInvoicesPaymentsPending_AllPaymentsArray(){
  if (confirm('Are you sure you want to delete all payment etries and all restore all invoices as unpaid in the list? x: ' + this.gfunc.set_max_sync_number)) {
      for (let i = 0; i < this.gfunc.set_max_sync_number; i++) {
        // console.log ("Block statement execution no." + this.pending_clients_invoices_payments[i].subject_number);
        console.log(JSON.stringify(this.pending_clients_invoices_payments[i]))
 
        this.deletePaymentAndInvoicePayment(this.pending_clients_invoices_payments[i])
        console.log ("Block statement execution no." + this.pending_clients_invoices_payments[i].subject_number);          
         }
  this.getPendingClientsInvoicesPayments()

}
}



deletePaymentAndInvoicePayment(model) {
  // if (confirm('Are you sure you want to delete this payment entry?')) {
    this._demoService.deletePaymentAndInvoicePayment(model).subscribe(
      (data) => {
        this.invoice_deleted_data = data;
        let res = data[0];

              this.invoice_update_payment_model = {
                invoice_id: model.invoice_id,
                invoice_payment_total: 0,
                // invoice_remaining_total: model.invoice_total,
                invoice_remaining_total: model.payment_total, // set the total remaining back from the total that was paid.
                // invoice_remaining_total: 65.5, // set the total remaining back from the total that was paid.
                invoice_status_id: 3, // approved
                invoice_payment_status_id: 1, // outstanding
                updated_by: this.gfunc.sessionUserId,
                updated_date: this.gfunc.today
              };


// $invoice_id = $request->getParam('invoice_id');
// $invoice_payment_total = $request->getParam('invoice_payment_total');
// $invoice_remaining_total = $request->getParam('invoice_remaining_total');
// $invoice_status_id = $request->getParam('invoice_status_id');
// $invoice_payment_status_id = $request->getParam('invoice_payment_status_id');
// $updated_by = $request->getParam('updated_by');

// $updated_date = date('Y-m-d H:i:s', $_SERVER['REQUEST_TIME']); 


      },
      (err) => {
        console.log(err.error)
      
      
          // // Need to set some error varibles
          // this.error_message = err.error.error_message;
          // this.error_message_standard = err.error.error_message_standard;
          // this.error_name = err.error.error_name;
          // this.full_response_data = err.error.full_response_data;
          // this.data_sent = err.error.data_sent;
          // this.data_sent_id = err.error.data_sent_invoice_id;

          this.response_from_node = JSON.stringify(err)
          this.response_from_node_raw = err;
          console.log('FullRespoonse Error createMyobWorkOrderModel(model, data_work_order): ' + this.response_from_node)
          return(this.response_from_node = JSON.stringify(err)); // do this so other componets get
      
      }
      ,
     () => {
     this.updateInvoiceAfterPaymentFiguresLocal(this.invoice_update_payment_model);
      // this.refreshSujectInvoicePage(this.subject_id);
     }
    );
  // } // end confirm
  }
// // Loads from add new billing items modal.
// refreshInvoiceItemsBelow() {
//   console.log('Reloading Items');
//   this.getInvoiceItmes(this.invoice_id);
// }



// just updates local details
updateInvoiceAfterPaymentFiguresLocal(model){
  this._demoService.updateInvoiceAfterPaymentFigures(model).subscribe(
    (data) => {
     // this.new_payment_id = data;
     let res = data[0];
this.toastr.success('Payment + Invoice Record(s) Applied');
// this.gfunc.globalJobSubjectBillingViewSkipRoute(this.subject_id);
// this.gfunc.insertLog_DeleteInvoicePayment(model);

},
(err) => console.error(err),
() => {
}
);
}






 getPendingAgentsInvoicesPayments() {
  this.isShowSpinnerAgentsInvoicesPayments = 1;
  this._demoService.getPendingAgentsInvoicesPayments().subscribe(
     data => { this.pending_agents_invoices_payments = data;
      let res = data[0];
      this.count_pending_agents_invoices_payments = this.pending_agents_invoices_payments.length;
    this.isShowSpinnerAgentsInvoicesPayments = 0;

    },
     err => (console.error(err),
    this.isShowSpinnerAgentsInvoicesPayments = 0
     )
     // () => console.log('done loading Trace Types')
   );
 }


 RemoveAllAgentsInvoicesPaymentsPending_AllPaymentsArray(){
  if (confirm('Are you sure you want to delete all payment etries and all restore all invoices as unpaid in the list? x: ' + this.gfunc.set_max_sync_number)) {
      for (let i = 0; i < this.gfunc.set_max_sync_number; i++) {
        // console.log ("Block statement execution no." + this.pending_agents_invoices_payments[i].subject_number);
        console.log(JSON.stringify(this.pending_agents_invoices_payments[i]))
 
//  new function here.
        this.deletePaymentAndWorkOrderPayment(this.pending_agents_invoices_payments[i])

        // console.log ("Block statement execution no." + this.pending_agents_invoices_payments[i].subject_number);          
         }
  this.getPendingAgentsInvoicesPayments()

}
}



deletePaymentAndWorkOrderPayment(model) {
  // if (confirm('Are you sure you want to delete this payment entry?')) {
    this._demoService.deletePaymentAndWorkOrderPayment(model)
    .pipe(
      retry(0), // you retry 3 times
      delay(1500) // each retry will start after 1 second,
   )
    .subscribe(
      (data) => {
        this.work_prder_deleted_data = data;
        let res = data[0];
              // there was a bug here causing the payments to fractture on delete. totals were wrong now fixed 
              this.work_order_update_payment_model = {
                work_order_id: model.work_order_id,
                work_order_payment_total: 0,
                // work_order_remaining_total: model.work_order_total,
                work_order_remaining_total: model.spending_total,
                work_order_status_id: 3, // approved
                work_order_payment_status_id: 1, // outstanding
                updated_by: this.gfunc.sessionUserId,
                updated_date: this.gfunc.today
              };
      },
      (err) => console.log(err.error),
     () => {
      this.updateWorkOrderAfterPaymentFigures(this.work_order_update_payment_model);
      // this.refreshSujectInvoicePage(this.subject_id);
     }
    );
  // } // end confirm
  }



updateWorkOrderAfterPaymentFigures(model){
    this._demoService.updateWorkOrderAfterPaymentFigures(model).subscribe(
      (data) => {
       // this.new_spending_id = data;
       let res = data[0];
  this.toastr.success('Spending + Invoice Record(s) Applied');
  // :: TOD refresh the invoice modal below.
  // // May need these but was causing a very slow system.
  // this.closeParentModel3.emit();
  // this.closeParentModel2.emit();
  // this.gfunc.insertLog_DeletWorkOrderPayment(model);
  // this.closeParentModel.emit();
  // this.refreshWorkOrderItemsBelow.emit();
  },
  (err) => console.error(err),
  () => {}
  );
  }


 postNewApprovedContactsCustomersFromTSA() {

  // 07/02/24 -- Myob Checker On First Run.
  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

  // Remove from array early.
 this.pending_clients = [];


  this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedContactsCustomers/fromTSA')
  // .pipe(
  //   this.toastr.observe({
  //     loading: 'Checking... Action: postNewApprovedContactsCustomers...',
  //     success: '🚀...weeeeeee',
  //     error: '...😡...'
  //  })
  //  )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_customers_result = data;

    let res = data[0];
  console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);
 

    // refreshnumbers\
    // this.isShowSpinnerClientsSync = 0;
    // this.StartRunIntervalFuntions()
    // this.getPendingClients(); 


    let set_delay; // Added Time based in time taked with max and node app response. // 18000
    // smaller delay if count is less then the maximum -- NEW.
    if(this.count_pending_clients <= this.gfunc.set_max_sync_number){
      set_delay = (5100 * this.count_pending_clients); // Added Time based in time taked with max and node app response. // 18000
    }else{
    set_delay = (5100 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
     }
    this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
    setTimeout(() => {  
    this.getPendingClients(); 
    this.isShowSpinnerClientsSync = 0;
    this.StartRunIntervalFuntions()
    }, set_delay )

  
  
},
err => {
  

this.toastr.success('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.data_sent.CustomField1.Value;
  this.data_sent_DisplayID = err.error.data_sent.DisplayID;

  this.data_sent_client_brand_id = err.error.brand_id;
  this.data_sent_agent_brand_id = null;


  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;

    // refreshnumbers
    this.isShowSpinnerClientsSync = 0; 
    this.StartRunIntervalFuntions()

});



}





postNewApprovedContactsSuppliersFromTSA() {

  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

// Remove from array early.
this.pending_agents = [];


  this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedContactsSuppliers/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewApprovedContactsCustomers...',
      success: '🚀...weeeeeee',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_customers_result = data;

    let res = data[0];
  console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);

      // refreshnumbers\
      // this.isShowSpinnerAgentsSync = 0;
      // this.StartRunIntervalFuntions()
      // this.getPendingAgents();


      let set_delay; // Added Time based in time taked with max and node app response. // 18000
      // smaller delay if count is less then the maximum -- NEW.
      if(this.count_pending_agents <= this.gfunc.set_max_sync_number){
        set_delay = (5100 * this.count_pending_agents); // Added Time based in time taked with max and node app response. // 18000
      }else{
      set_delay = (5100 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
       }
      this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
      setTimeout(() => {  
        this.StartRunIntervalFuntions()
        this.isShowSpinnerAgentsSync = 0;
        this.getPendingAgents();
      }, set_delay )


},
err => {
this.toastr.success('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.data_sent.CustomField1.Value;
  this.data_sent_DisplayID = err.error.data_sent.DisplayID;

  this.data_sent_client_brand_id = null;
  this.data_sent_agent_brand_id = err.error.brand_id;


  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;


        // refreshnumbers\
        this.isShowSpinnerAgentsSync = 0;
        this.StartRunIntervalFuntions()
  

});

}


postNewApprovedCustomerInvoicesFromTSA() {

  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

// Remove from array early.
 this.pending_clients_invoices = [];


  this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedInvoices/fromTSA')
  // this.http.post(this.gfunc.sopNodeURL + '/postNewApprovedInvoices/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewApprovedInvoices ...',
      success: '🚀...',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_customers_invoices_result = data;

    let res = data[0];
  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);
  
  this.toastr.info('Pushing invoices now, Your Client Invoice counts should decrease by: ' + this.gfunc.set_max_sync_number )
       
      // refreshnumbers\
      //  this.isShowSpinnerClientsInvoicesSync = 0;
      //  this.toastr.info('wait a tick....')
       // test to see if we wait a little bit more all pushing has completed.
       let set_delay; // Added Time based in time taked with max and node app response. // 18000
       // smaller delay if count is less then the maximum -- NEW.
       if(this.count_pending_clients_invoices <= this.gfunc.set_max_sync_number){
         set_delay = (5100 * this.count_pending_clients_invoices); // Added Time based in time taked with max and node app response. // 18000
       }else{
       set_delay = (5100 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
        }
       this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
      //  this.estimated_time_clientsinvoices = this.millisToMinutesAndSeconds(set_delay); 

       setTimeout(() => {  
        this.getPendingClientsInvoices();
       this.isShowSpinnerClientsInvoicesSync = 0;
       this.StartRunIntervalFuntions()
      }, set_delay)
    


},
(err) => {
this.toastr.success('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.data_sent.CustomField1.Value;
  this.data_sent_DisplayID = err.error.data_sent.DisplayID;

  this.data_sent_client_brand_id = null;
  this.data_sent_agent_brand_id = null;
  this.data_sent_invoice_id = err.error.invoice_id;
  this.data_sent_agent_invoice_id = null;

  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;

        // refreshnumbers\
        this.isShowSpinnerClientsInvoicesSync = 0;
        this.StartRunIntervalFuntions()
        this.getPendingClientsInvoices();

});


}


  


  clearSearchResults(){
    this.search_results = [];
    // this.comparitor_array_A = [];
    this.toastr.info('Clearing All in Actions list.')
  }


  
pushClientInvoiceToSearchItems(invoice_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object


      // if single

  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
if (!this.search_results.some(el => el.invoice_id === invoice_model.invoice_id)) {
  this.search_results.push({
    // JSON.stringify(invoice_model)
    ...invoice_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
    invoiceUID: invoice_model.myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
  });
}


}



  
pushAgentToSearchItems(brand_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object


      // if single

  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
if (!this.search_results.some(el => el.brand_id === brand_model.brand_id)) {
  this.search_results.push({
    // JSON.stringify(invoice_model)
    ...brand_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
    BrandUID: brand_model.myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
  });
}
}




// Object model.
pushClientsToSearchItems(brand_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // if(count){
    //   loop_count = count;
    // }

    let loop_count = brand_model.length

    // less than so that it does not automatically loop 20x with no content.
      // if(this.invoice_model.length <= this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.invoice_model.length
      // }

      // if(this.invoice_model.length > this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...brand_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                UID: brand_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Automatically Run the list.
   this.listAction_addClientsMyob();

      // if single




}






  
pushClientToSearchItems(brand_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object


      // if single

  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
if (!this.search_results.some(el => el.brand_id === brand_model.brand_id)) {
  this.search_results.push({
    // JSON.stringify(invoice_model)
    ...brand_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
    BrandUID: brand_model.myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
  });
}
}





// Object model.
pushAgentsToSearchItems(brand_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // if(count){
    //   loop_count = count;
    // }

    let loop_count = brand_model.length

    // less than so that it does not automatically loop 20x with no content.
      // if(this.invoice_model.length <= this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.invoice_model.length
      // }

      // if(this.invoice_model.length > this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...brand_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                UID: brand_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Automatically Run the list.
   this.listAction_addAgentsMyob();

      // if single




}






// Object model.
pushClientInvoicesToSearchItems(invoice_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // if(count){
    //   loop_count = count;
    // }

    let loop_count = invoice_model.length

    // less than so that it does not automatically loop 20x with no content.
      // if(this.invoice_model.length <= this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.invoice_model.length
      // }

      // if(this.invoice_model.length > this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...invoice_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                invoiceUID: invoice_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Automatically Run the list.
    this.listAction_addClientInvoicesMyob();

      // if single




}


// Object model.
pushAgentInvoicesToSearchItems(work_order_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // if(count){
    //   loop_count = count;
    // }

    let loop_count = work_order_model.length

    // less than so that it does not automatically loop 20x with no content.
      // if(this.invoice_model.length <= this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.invoice_model.length
      // }

      // if(this.invoice_model.length > this.gfunc.set_max_sync_number && this.invoice_model.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...work_order_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                WorkOrderUID: work_order_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Automatically Run the list.
    this.listAction_addAgentInvoicesMyob();

      // if single




}

  
pushClientInvoicePaymentToSearchItems(invoice_payment_model){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object


      // if single

  // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
if (!this.search_results.some(el => el.invoice_id === invoice_payment_model.invoice_id)) {
  this.search_results.push({
    // JSON.stringify(invoice_model)
    ...invoice_payment_model, // this little bit of code maps the json objects/models together without having to do it all by hand.
    invoiceUID: invoice_payment_model.myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
  });
}
}








millisToMinutesAndSeconds(millis) {
  var minutes = Math.floor(millis / 60000);
  var seconds: any = ((millis % 60000) / 1000).toFixed(0);
  return minutes + ":" + (seconds <= 10 ? '0' : '') + seconds;
}



NEW_makeRequest = async () => {
  try {
      let res = await this.postNewApprovedCustomerInvoicesFromTSA();
      // let clubs = await getClubsForUser(user.id);
      console.log(JSON.stringify(res));
   }
  catch(err) {
      // console.log(err.message);

      this.toastr.success('We encounted issues please refer to below,...', err.error);
      console.error(err);
      this.response_from_node = JSON.stringify(err);
      this.response_from_node_raw = err;
        
      // Need to set some error varibles
        this.error_message = err.error.error_message;
        this.error_message_standard = err.error.error_message_standard;
        this.error_name = err.error.error_name;
        this.full_response_data = err.error.full_response_data;
        this.data_sent = err.error.data_sent;
        this.data_sent_id = err.error.data_sent.CustomField1.Value;
        this.data_sent_DisplayID = err.error.data_sent.DisplayID;
      
        this.data_sent_client_brand_id = null;
        this.data_sent_agent_brand_id = null;
        this.data_sent_invoice_id = err.error.invoice_id;
        this.data_sent_agent_invoice_id = null;
      
        this.full_response_status = err.error.full_response_staus;
        this.full_response_headers = err.error.full_response_headers;
        this.full_response = err.error.full_response;

 }
};


postNewApprovedSupplierInvoicesFromTSA() {
  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

 this.pending_agents_invoices = [];


  this.http.get(this.gfunc.sopNodeURL + '/postNewApprovedWorkOrders/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewApprovedSupplierInvoices ...',
      success: '🚀...',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_supplier_invoices_result = data;

    let res = data[0];
  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);

  this.toastr.info('Pushing invoices now, Your Agent Invoice counts should decrease by:' + this.gfunc.set_max_sync_number);
  
        // refreshnumbers\
        // this.isShowSpinnerAgentsInvoicesSync = 0;
        // this.StartRunIntervalFuntions()
        // this.getPendingAgentsInvoices();

        let set_delay; // Added Time based in time taked with max and node app response. // 18000
        // smaller delay if count is less then the maximum -- NEW.
        if(this.count_pending_agents_invoices <= this.gfunc.set_max_sync_number){
          set_delay = (5100 * this.count_pending_agents_invoices); // Added Time based in time taked with max and node app response. // 18000
        }else{
        set_delay = (5100 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
         }
        this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
        setTimeout(() => {  
         this.getPendingAgentsInvoices();
         this.isShowSpinnerAgentsInvoicesSync = 0;
         this.StartRunIntervalFuntions()
        }, set_delay )


},
err => {
this.toastr.error('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.data_sent.CustomField1.Value;
  this.data_sent_DisplayID = err.error.data_sent.DisplayID;

  this.data_sent_client_brand_id = null;
  this.data_sent_agent_brand_id = null;
  this.data_sent_invoice_id = null;
  this.data_sent_agent_invoice_id = err.error.invoice_id;


  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;


          // refreshnumbers\
          this.isShowSpinnerAgentsInvoicesSync = 0;
          this.StartRunIntervalFuntions()
          this.getPendingClients(); 
          this.getPendingClientsInvoices();
          this.getPendingClientsInvoicesPayments();
          this.getPendingAgents();
          this.getPendingAgentsInvoices();
          this.getPendingAgentsInvoicesPayments();

});


}


postNewClientInvoicePaymentsFromTSA() {

  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

// Remove from array early.
this.pending_clients_invoices_payments = [];

  this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewInvoicePayments ...',
      success: '🚀...',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_customer_invoice_payments_result = data;

    let res = data[0];
  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);

this.toastr.info('Your Sync is underway. We are putting payments now... Your counts remaining should go down by: ' + this.gfunc.set_max_sync_number )


          // refreshnumbers\

          let set_delay; // Added Time based in time taked with max and node app response. // 18000
          // smaller delay if count is less then the maximum -- NEW.
          if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
            set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
          }else{
          set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
           }
          this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
          setTimeout(() => {  
            this.getPendingClientsInvoicesPayments();
            this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
            this.StartRunIntervalFuntions()
          }, set_delay )




},
err => {
this.toastr.success('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.payment_id;
  this.data_sent_DisplayID = err.error.data_sent.customer_UID;

  //Set these up for payments
  this.data_sent_client_brand_id = err.error.customer_UID;
  this.data_sent_agent_brand_id = null;
  this.data_sent_invoice_id = err.error.invoice_UID;
  this.data_sent_invoice_UID = err.error.invoice_UID;
  this.data_sent_client_invoice_id = err.error.invoice_id;
  this.data_sent_agent_invoice_id = null;
if(this.data_sent_invoice_UID != null){
  this.getSubjectInvoiceByInvoiceByUID(this.data_sent_invoice_UID) // gets the invoice the payment was applied to.

}
  this.data_sent_invoice_payment_id = err.error.payment_id;
  this.data_sent_work_order_payment_id = null;


  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;

         // refreshnumbers\
         this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
         this.StartRunIntervalFuntions()


});
}


postNewClientSupplierPaymentsFromTSA() {

  this.gfunc.myobChecker(); // Now a global Fuctnion
  clearInterval(this.interval);  // Stop Numbers
  this.clearErrorResponses()

  // Remove from array early.
 this.pending_agents_invoices_payments = [];


  this.http.get(this.gfunc.sopNodeURL + '/postNewWorkOrderPayments/fromTSA')
  .pipe(
    this.toastr.observe({
      loading: 'Checking... Action: postNewWorkOrderPayments ...',
      success: '🚀...',
      error: '...😡...'
   })
   )
  .pipe(
    retry(0), // you retry 3 times
    delay(1500) // each retry will start after 1 second,
 ).subscribe(
  data => { this.post_new_approved_supplier_invoice_payments_result = data;

    let res = data[0];
  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
  this.response_from_node = JSON.stringify(data);

       // refreshnumbers\
       
this.toastr.info('Your Sync is underway. We are putting payments now... Your counts remaining should go down by: ' + this.gfunc.set_max_sync_number )

 
let set_delay; // Added Time based in time taked with max and node app response. // 18000
// smaller delay if count is less then the maximum -- NEW.
if(this.count_pending_agents_invoices_payments <= this.gfunc.set_max_sync_number){
  set_delay = (5100 * this.count_pending_agents_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
}else{
set_delay = (5100 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
 }
       this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
       setTimeout(() => {  
        this.StartRunIntervalFuntions()
        this.isShowSpinnerAgentsInvoicesPaymentsSync = 0;
        this.getPendingAgentsInvoicesPayments();
       }, set_delay )




},
err => {
this.toastr.success('We encounted issues please refer to below,...', err.error);
console.error(err);
this.response_from_node = JSON.stringify(err);
this.response_from_node_raw = err;
  
// Need to set some error varibles
  this.error_message = err.error.error_message;
  this.error_message_standard = err.error.error_message_standard;
  this.error_name = err.error.error_name;
  this.full_response_data = err.error.full_response_data;
  this.data_sent = err.error.data_sent;
  this.data_sent_id = err.error.payment_id;
  this.data_sent_DisplayID = err.error.data_sent.DisplayID;


  //Set these up for payments
  this.data_sent_client_brand_id = null;
  this.data_sent_agent_brand_id = err.error.supplier_UID;
  this.data_sent_work_order_id = err.error.work_order_UID;
  this.data_sent_work_order_UID = err.error.work_order_UID;


  this.data_sent_client_invoice_id = null;
  this.data_sent_agent_work_order_id = err.error.work_order_UID;

    if(this.data_sent_work_order_UID != null){
      this.getSubjectWorkOrderByUID(this.data_sent_work_order_UID) // gets the invoice the payment was applied to.
    }
  this.data_sent_invoice_payment_id = null;
  this.data_sent_work_order_spending_id = err.error.spending_id;


  this.full_response_status = err.error.full_response_staus;
  this.full_response_headers = err.error.full_response_headers;
  this.full_response = err.error.full_response;


         // refreshnumbers\
         this.isShowSpinnerAgentsInvoicesPaymentsSync = 0;
         this.StartRunIntervalFuntions()

});
}










getSubjectInvoiceByInvoiceByUID(UID){
  this._demoService.getSubjectInvoiceByUID(UID).subscribe(
    (data) => {
      this.invoiceItem = data;
      let res = data[0];
      this.invoice_number = res.invoice_number;
      this.invoice_total = res.total;
     this.invoice_model = this.invoiceItem;
     this.invoice_payment_status = res.invoice_payment_status_id;
     
     this.toastr.info("loading invoice of payment complete." + UID)

     // make the form invalid if invoice not paid.
     // overpay
              // if (res.invoice_payment_status_id != 2){
              //   this.toastr.warning('Invoice payment still pending!');
              // // set the form to invalid for entry
              // this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
              //   }

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.subject_number = res.subject_number;
     this.job_number = res.job_number;
     this.job_id = res.job_id;
     this.subject_id = res.subject_id;
     this.invoice_id = res.invoice_id


    },
    (err) => {
      this.toastr.error("loading invoice of payment not loaded." + UID)
      console.error(err)
    },
   // () => console.log('Brand Loaded.')
  );
}




getSubjectWorkOrderByUID(UID){
  this._demoService.getSubjectWorkOrderByUID(UID).subscribe(
    (data) => {
      // this.invoiceItem = data;
      // let res = data[0];
     
      this.workOrderItem = data;
     let res = data[0];
     this.work_order_number = res.work_order_number;

     
     
      this.work_order_number = res.work_order_number;
      this.work_order_total = res.total;
     this.invoice_model = this.invoiceItem;
     this.work_order_payment_status = res.work_order_payment_status_id;
     
     this.toastr.info("loading supplier invoice of payment complete." + UID)

     // make the form invalid if invoice not paid.
     // overpay
              // if (res.invoice_payment_status_id != 2){
              //   this.toastr.warning('Invoice payment still pending!');
              // // set the form to invalid for entry
              // this.invoicePaymentForm.form.controls['remaining_total'].setErrors({'incorrect': true});
              //   }

     // :: set the form variables of the payment form // these are traditionally not apart of the paymentModel
     // ... so might change form to invoicePaymentModel instead?
     this.subject_number = res.subject_number;
     this.job_number = res.job_number;
     this.job_id = res.job_id;
     this.subject_id = res.subject_id;
     this.work_order_id = res.work_order_id

    },
    (err) => {
      this.toastr.error("loading supplier invoice of payment not loaded." + UID)
      console.error(err)
    },
   // () => console.log('Brand Loaded.')
  );
}

// This recieves the sent respose from the main component and sets the value
sendResponse(response_from_node){

  
let data = response_from_node;
  this.response_from_node = JSON.stringify(response_from_node);
 this.toastr.info('...Data Sent -- sendResponse()...');
let err = response_from_node;
this.response_from_node_raw = err;

// Need to set some error varibles
    this.error_message = err.error.error_message;
    this.error_message_standard = err.error.error_message_standard;
    this.error_name = err.error.error_name;
    this.full_response_data = err.error.full_response_data;
    this.data_sent = err.error.data_sent;
    this.data_sent_id = err.error.payment_id;
    this.data_sent_DisplayID = err.error.data_sent.DisplayID;


    //Set these up for payments
    this.data_sent_client_brand_id = null;
    this.data_sent_agent_brand_id = err.error.supplier_UID;
    this.data_sent_work_order_id = err.error.work_order_UID;
    this.data_sent_work_order_UID = err.error.work_order_UID;


    this.data_sent_client_invoice_id = null;
    this.data_sent_agent_work_order_id = err.error.work_order_UID;

      if(this.data_sent_work_order_UID != null){
        this.getSubjectWorkOrderByUID(this.data_sent_work_order_UID) // gets the invoice the payment was applied to.
      }
    this.data_sent_invoice_payment_id = null;
    this.data_sent_work_order_spending_id = err.error.spending_id;


    this.full_response_status = err.error.full_response_staus;
    this.full_response_headers = err.error.full_response_headers;
    this.full_response = err.error.full_response;

};




// :: Widget 
widgetPushAllClientInvoices(model){
  // loop the function with the results 
  this.job_notes_removed = 0;
  this.job_notes_removed = 0;

  let newArr = model;
console.log('NewArr-' + JSON.stringify(newArr));

  let  count_of_items = Object.keys(newArr).length;
  console.log('Items to sync: ' +count_of_items)

  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
   
    // Buildl the model to push and push 

   // Run the Single push invcoice Route and 
    
 this.clientInvoiceTools.setMyobInvoiceModelStep1(newArr[i]);
  // this.sendResponse(res_test);



  


   // try to map this funtion.


  //  this.toastr.success('Invoice Done ' + newArr[i].invoice_number);
   //  this.deleteJobNotes(newArr[i].job_id);
    
   
   // increases the count
    //  this.job_notes_count_removed++;

  } // end for loop

// this.job_notes_removed = 1;

};



// :: Widget 
widgetPushAllClientInvoices_array(model){
  
  
  for (const item of model) {
    //do something
    // setTimeout(() => {  
    //   console.log("A Simple Pause!");
    //   this.clientInvoiceTools.setMyobInvoiceModelStep1(item);
    //   }, 4000);
  }

//   model.forEach(function(item){ 
//     //iterate on something 
//     this.clientInvoiceTools.setMyobInvoiceModelStep1(item);
//     console.log('working on Invoice: ' + item.Number)
// })
console.log("ForEach Done.")
  
  
            
            // loop the function with the results 
            this.job_notes_removed = 0;
            this.job_notes_removed = 0;

            let newArr = model;
          console.log('NewArr-' + JSON.stringify(newArr));

            let  count_of_items = Object.keys(newArr).length;
            console.log('Items to sync: ' +count_of_items)

            for(let i=0;i < count_of_items; i++) {
               let res = newArr[i];
            
              // Buildl the model to push and push 

             // Run the Single push invcoice Route and 
             setTimeout(() => {  
              console.log("A Simple Pause!");
             this.clientInvoiceTools.setMyobInvoiceModelStep1(newArr[i]);
              }, 4000);
            //  this.clientInvoiceTools.setMyobInvoiceModelStep1(newArr[i]);
            //  this.toastr.success('Invoice Done ' + newArr[i].invoice_number);
             //  this.deleteJobNotes(newArr[i].job_id);
              
            
             // increases the count
              //  this.job_notes_count_removed++;

            } // end for loop

          // this.job_notes_removed = 1;

};




// :: Widget 
widgetPushAllAgentInvoices(model){

  let newArr = model;
// console.log('NewArr-' + JSON.stringify(newArr));

  let  count_of_items = Object.keys(newArr).length;
  console.log('Items to sync: ' +count_of_items)

  for(let i=0;i < count_of_items; i++) {
     let res = newArr[i];
   this.agentInvoiceTools.setMyobWorkOrderModelStep1(newArr[i]);
  //  this.toastr.success('Invoice Done ' + newArr[i].invoice_number);
  } // end for loop
};





 // MODAL
// start of modal windows service as a template
openModal(template: TemplateRef<any>) {
  // small upgrade to disable background click on open modal background
  const config = { backdrop: true, ignoreBackdropClick: true, class: 'gray modal-lg' };
  this.modalRef = this.modalService.show(template, config);
}


// :: Parent / Child modal test
closeParentModel() {
  // alert('parent component function.');
 // this.modalService.hide(1); - removed the scroll bard do not use!!!
  this.modalRef.hide();
 // this.getJobPlaintiffs(this.job_id);
 // this.refreshGrid(); // resets the grid if updated and closed.
//  this.updateTypeClick = false; // closes the div
// :: reset the entire page.
// this.gfunc.globalJobViewSkipRoute(this.job_id);

};



   // this counld be the 
   listAction_addClientInvoicesMyob_ORIGINAL(){
    if (confirm('Are you sure you want push all these invoices to MYOB and update local data? : x' + this.gfunc.set_max_sync_number)) {

      let loop_count = 0;
        // less than so that it does not automatically loop 20x with no content.
          if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
          loop_count = this.search_results.length
          }

          if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
          loop_count = this.gfunc.set_max_sync_number
          }

        for (let i = 0; i < loop_count; i++) {
          // console.log ("Block statement execution no." + this.pending_agents_invoices_payments[i].subject_number);
          console.log(JSON.stringify(this.search_results[i]))
    
  //  new function here.
          // this.deletePaymentAndWorkOrderPayment(this.pending_agents_invoices_payments[i])
          // this.deleteMyobServiceInvoiceModel(this.search_results[i])
      //  let return_result = this.myobApi_ITW.setMyobInvoiceModelStep1(this.search_results[i])
         
      
      this.myobApi_ITW.setMyobInvoiceModelStep1(this.search_results[i])
      console.log ("Block statement execution no." + this.search_results[i].invoice_number);          
        
        
          //  return return_result;
         
          // console.log ("Block statement execution no." + i)          
            }
    // this.getPendingAgentsInvoicesPayments()
  
  }
  }





  listAction_addClientsMyob(){
    if (confirm('Are you sure you want push all these Clients to MYOB and update local data? : x' + this.search_results.length)) {
      this.isShowSpinnerClientsSync = 1;
      // let loop_count = 25;
      // let loop_count = this.search_results.length;
  
        // less than so that it does not automatically loop 20x with no content.
          // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
          // loop_count = this.search_results.length
          // }
  
          // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
          // loop_count = this.gfunc.set_max_sync_number
          // }
  
      
      
         
  let search_results = [];
  search_results = this.search_results; // set as a constant.
  
  
      let loop_count = search_results.length;
  
      (async () => {
        this.isShowSpinnerClientsSync = 1;
        for (let i = 0; i < loop_count; i++) { // 
  
  let a = i;
      
      //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.
  
  
  
                  // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                  let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                  this.http.post(this.gfunc.sopNodeURL + '/postNewApprovedContactsCustomers/fromTSA', body, httpOptions)
                  .pipe(
                  this.toastr.observe({
                    loading: 'Checking... Action: postNewCustomers ...',
                    success: '🚀...',
                    error: '...😡...'
                  })
                  )
                  .pipe(
                  retry(0), // you retry 3 times
                  delay(1500) // each retry will start after 1 second,
                  ).subscribe(
                  data => { this.post_new_approved_customers_result = data;
  
                  let res = data[0];
  
                  console.log('ressponse: ' + JSON.stringify(res))
                  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                  this.response_from_node = JSON.stringify(data);
  
                  this.toastr.info('Customer Complete: = ' + search_results[i].name )
  
  
         
                    // Experiment to get the index and change
                  // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                  // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                  // :: Simple and cool way to update the model.
                
                
                  let  objIndex =  search_results.findIndex(obj => obj.brand_id == search_results[i].brand_id);
                  search_results[objIndex].RowVersion = "DONE";
  
                      // end resoponse.
                      console.log('Count: ' + i)
                  if(i == (loop_count - 1)){
      
                    this.isShowSpinnerClientsSync = 0;
                    this.toastr.success("We have processed the full action list.")
                   this.clearSearchResults(); // I now clear the array
                  }
                        // refreshnumbers\
  
                        // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                        // // smaller delay if count is less then the maximum -- NEW.
                        // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                        //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                        // }else{
                        // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                        //   }
                        // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                        // setTimeout(() => {  
                        //   this.getPendingClientsInvoicesPayments();
                        //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                        //   this.StartRunIntervalFuntions()
                        // }, set_delay )
  
            //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                        this.getPendingClients();
      
  
                  },
                  err => {
                  this.toastr.success('We encounted issues please refer to below,...', err.error);
                          // refreshnumbers\
                          // this.isShowSpinnerClientsInvoicesSync = 0;
                          // this.StartRunIntervalFuntions()
              let  objIndex =  search_results.findIndex(obj => obj.brand_id == search_results[i].brand_id);
              search_results[objIndex].RowVersion = "ERROR";
      
                          this.toastr.success('We encounted issues please refer to below,...', err.error);
                          console.error(err);
                          this.response_from_node = JSON.stringify(err);
                          this.response_from_node_raw = err;
                            
                          // Need to set some error varibles
                            this.error_message = err.error.error_message;
                            this.error_message_standard = err.error.error_message_standard;
                            this.error_name = err.error.error_name;
                            this.full_response_data = err.error.full_response_data;
                            this.data_sent = err.error.data_sent;
                            this.data_sent_id = err.error.data_sent.CustomField1.Value;
                            this.data_sent_DisplayID = err.error.data_sent.DisplayID;
                          
                            this.data_sent_client_brand_id = null;
                            this.data_sent_agent_brand_id = null;
                            this.data_sent_invoice_id = err.error.invoice_id;
                            this.data_sent_agent_invoice_id = null;
                          
                            this.full_response_status = err.error.full_response_staus;
                            this.full_response_headers = err.error.full_response_headers;
                            this.full_response = err.error.full_response;
                          
                            
                            // this.getPendingClientsInvoices();
  
                
  
                  }
                  
                  );
  
  
  
  
        console.log ("Block statement execution no." + this.search_results[i].subject_number);       
            // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
            this.toastr.success('Processing');
            // this.toastr.info("Inside")
  
  
     await this.delay(5000); // works perfect. for search_results lists
            // await this.delay(15000); // works perfect. (11000)
                  // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
               
         
  
  
     
         }
        //  this.getPendingClientsInvoicesPayments();
     
      })(); // end async function
        
  
  
            // this.getPendingClientsInvoicesPayments();
    
            // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
         
            // this.toastr.success("We have processed the full action list.")
    // this.getPendingAgentsInvoicesPayments()
  
  }
  
  
  
  }
  


  listAction_addAgentsMyob(){
    if (confirm('Are you sure you want push all these Agents to MYOB and update local data? : x' + this.search_results.length)) {
      this.isShowSpinnerAgentsSync = 1;
      // let loop_count = 25;
      // let loop_count = this.search_results.length;
  
        // less than so that it does not automatically loop 20x with no content.
          // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
          // loop_count = this.search_results.length
          // }
  
          // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
          // loop_count = this.gfunc.set_max_sync_number
          // }
  
      
      
         
  let search_results = [];
  search_results = this.search_results; // set as a constant.
  
  
      let loop_count = search_results.length;
  
      (async () => {
        this.isShowSpinnerAgentsSync = 1;
        for (let i = 0; i < loop_count; i++) { // 
  
  let a = i;
      
      //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.
  
  
  
                  // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                  let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                  this.http.post(this.gfunc.sopNodeURL + '/postNewApprovedContactsSuppliers/fromTSA', body, httpOptions)
                  .pipe(
                  this.toastr.observe({
                    loading: 'Checking... Action: postNewSuppliers ...',
                    success: '🚀...',
                    error: '...😡...'
                  })
                  )
                  .pipe(
                  retry(0), // you retry 3 times
                  delay(1500) // each retry will start after 1 second,
                  ).subscribe(
                  data => { this.post_new_approved_supplier_invoices_result = data;
  
                  let res = data[0];
  
                  console.log('ressponse: ' + JSON.stringify(res))
                  // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                  this.response_from_node = JSON.stringify(data);
  
                  this.toastr.info('Customer Complete: = ' + search_results[i].name )
  
  
         
                    // Experiment to get the index and change
                  // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                  // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                  // :: Simple and cool way to update the model.
                
                
                  let  objIndex =  search_results.findIndex(obj => obj.brand_id == search_results[i].brand_id);
                  search_results[objIndex].RowVersion = "DONE";
  
                      // end resoponse.
                      console.log('Count: ' + i)
                  if(i == (loop_count - 1)){
      
                    this.isShowSpinnerAgentsSync = 0;
                    this.toastr.success("We have processed the full action list.")
                   this.clearSearchResults(); // I now clear the array
                  }
                        // refreshnumbers\
  
                        // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                        // // smaller delay if count is less then the maximum -- NEW.
                        // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                        //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                        // }else{
                        // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                        //   }
                        // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                        // setTimeout(() => {  
                        //   this.getPendingClientsInvoicesPayments();
                        //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                        //   this.StartRunIntervalFuntions()
                        // }, set_delay )
  
            //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                        this.getPendingAgents();
      
  
                  },
                  err => {
                  this.toastr.success('We encounted issues please refer to below,...', err.error);
                          // refreshnumbers\
                          // this.isShowSpinnerClientsInvoicesSync = 0;
                          // this.StartRunIntervalFuntions()
              let  objIndex =  search_results.findIndex(obj => obj.brand_id == search_results[i].brand_id);
              search_results[objIndex].RowVersion = "ERROR";
      
                          this.toastr.success('We encounted issues please refer to below,...', err.error);
                          console.error(err);
                          this.response_from_node = JSON.stringify(err);
                          this.response_from_node_raw = err;
                            
                          // Need to set some error varibles
                            this.error_message = err.error.error_message;
                            this.error_message_standard = err.error.error_message_standard;
                            this.error_name = err.error.error_name;
                            this.full_response_data = err.error.full_response_data;
                            this.data_sent = err.error.data_sent;
                            this.data_sent_id = err.error.data_sent.CustomField1.Value;
                            this.data_sent_DisplayID = err.error.data_sent.DisplayID;
                          
                            this.data_sent_client_brand_id = null;
                            this.data_sent_agent_brand_id = null;
                            this.data_sent_invoice_id = err.error.invoice_id;
                            this.data_sent_agent_invoice_id = null;
                          
                            this.full_response_status = err.error.full_response_staus;
                            this.full_response_headers = err.error.full_response_headers;
                            this.full_response = err.error.full_response;
                          
                            
                            // this.getPendingClientsInvoices();
  
                
  
                  }
                  
                  );
  
  
  
  
        console.log ("Block statement execution no." + this.search_results[i].subject_number);       
            // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
            this.toastr.success('Processing');
            // this.toastr.info("Inside")
  
  
     await this.delay(8000); // works perfect. for search_results lists
            // await this.delay(15000); // works perfect. (11000)
                  // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
               
         
  
  
     
         }
        //  this.getPendingClientsInvoicesPayments();
     
      })(); // end async function
        
  
  
            // this.getPendingClientsInvoicesPayments();
    
            // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
         
            // this.toastr.success("We have processed the full action list.")
    // this.getPendingAgentsInvoicesPayments()
  
  }
  
  
  
  }
  



listAction_addClientInvoicesMyob(){
  if (confirm('Are you sure you want push all these invoices to MYOB and update local data? : x' + this.gfunc.set_max_sync_number)) {
    this.isShowSpinnerClientsInvoicesSync = 1;
    // let loop_count = 25;
    // let loop_count = this.search_results.length;

      // less than so that it does not automatically loop 20x with no content.
        // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.search_results.length
        // }

        // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.gfunc.set_max_sync_number
        // }

    
    
       
let search_results = [];
search_results = this.search_results; // set as a constant.


    let loop_count = search_results.length;

    (async () => {
      this.isShowSpinnerClientsInvoicesSync = 1;
      for (let i = 0; i < loop_count; i++) { // 

let a = i;
    
    //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.



                // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                this.http.post(this.gfunc.sopNodeURL + '/postNewApprovedInvoices/fromTSA', body, httpOptions)
                .pipe(
                this.toastr.observe({
                  loading: 'Checking... Action: postNewInvoices ...',
                  success: '🚀...',
                  error: '...😡...'
                })
                )
                .pipe(
                retry(0), // you retry 3 times
                delay(1500) // each retry will start after 1 second,
                ).subscribe(
                data => { this.post_new_approved_customers_invoices_result = data;

                let res = data[0];

                console.log('ressponse: ' + JSON.stringify(res))
                // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                this.response_from_node = JSON.stringify(data);

                this.toastr.info('Invoice Complete: = ' + search_results[i].subject_number )


       
                  // Experiment to get the index and change
                // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                // :: Simple and cool way to update the model.
              
              
                let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                search_results[objIndex].RowVersion = "DONE";

                    // end resoponse.
                    console.log('Count: ' + i)
                if(i == (loop_count - 1)){
    
                  this.isShowSpinnerClientsInvoicesSync = 0;
                  this.toastr.success("We have processed the full action list.")
                 this.clearSearchResults(); // I now clear the array
                }
                      // refreshnumbers\

                      // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                      // // smaller delay if count is less then the maximum -- NEW.
                      // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                      //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                      // }else{
                      // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                      //   }
                      // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                      // setTimeout(() => {  
                      //   this.getPendingClientsInvoicesPayments();
                      //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                      //   this.StartRunIntervalFuntions()
                      // }, set_delay )

          //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                      this.getPendingClientsInvoices();
    

                },
                err => {
                this.toastr.success('We encounted issues please refer to below,...', err.error);
                        // refreshnumbers\
                        // this.isShowSpinnerClientsInvoicesSync = 0;
                        // this.StartRunIntervalFuntions()
            let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
            search_results[objIndex].RowVersion = "ERROR";
    
                        this.toastr.success('We encounted issues please refer to below,...', err.error);
                        console.error(err);
                        this.response_from_node = JSON.stringify(err);
                        this.response_from_node_raw = err;
                          
                        // Need to set some error varibles
                          this.error_message = err.error.error_message;
                          this.error_message_standard = err.error.error_message_standard;
                          this.error_name = err.error.error_name;
                          this.full_response_data = err.error.full_response_data;
                          this.data_sent = err.error.data_sent;
                          this.data_sent_id = err.error.data_sent.CustomField1.Value;
                          this.data_sent_DisplayID = err.error.data_sent.DisplayID;
                        
                          this.data_sent_client_brand_id = null;
                          this.data_sent_agent_brand_id = null;
                          this.data_sent_invoice_id = err.error.invoice_id;
                          this.data_sent_agent_invoice_id = null;
                        
                          this.full_response_status = err.error.full_response_staus;
                          this.full_response_headers = err.error.full_response_headers;
                          this.full_response = err.error.full_response;
                        
                          
                          // this.getPendingClientsInvoices();

              

                }
                
                );




      console.log ("Block statement execution no." + this.search_results[i].subject_number);       
          // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
          this.toastr.success('Processing');
          // this.toastr.info("Inside")


   await this.delay(8000); // works perfect. for search_results lists
          // await this.delay(15000); // works perfect. (11000)
                // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
             
       


   
       }
      //  this.getPendingClientsInvoicesPayments();
   
    })(); // end async function
      


          // this.getPendingClientsInvoicesPayments();
  
          // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
       
          // this.toastr.success("We have processed the full action list.")
  // this.getPendingAgentsInvoicesPayments()

}



}


listAction_addAgentInvoicesMyob(){
  if (confirm('Are you sure you want push all these invoices to MYOB and update local data? : x' + this.search_results.length)) {
    this.isShowSpinnerAgentsInvoicesSync = 1;
    // let loop_count = 25;
    // let loop_count = this.search_results.length;

      // less than so that it does not automatically loop 20x with no content.
        // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.search_results.length
        // }

        // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.gfunc.set_max_sync_number
        // }

    
    
       
let search_results = [];
search_results = this.search_results; // set as a constant.


    let loop_count = search_results.length;

    (async () => {
      this.isShowSpinnerAgentsInvoicesSync = 1;
      for (let i = 0; i < loop_count; i++) { // 

let a = i;
    
    //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.



                // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                this.http.post(this.gfunc.sopNodeURL + '/postNewApprovedWorkOrders/fromTSA', body, httpOptions)
                .pipe(
                this.toastr.observe({
                  loading: 'Checking... Action: postNewAgentInvoices ...',
                  success: '🚀...',
                  error: '...😡...'
                })
                )
                .pipe(
                retry(0), // you retry 3 times
                delay(3500) // each retry will start after 1 second,
                ).subscribe(
                data => { this.post_new_approved_supplier_invoices_result = data;

                let res = data[0];

                console.log('ressponse: ' + JSON.stringify(res))
                // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                this.response_from_node = JSON.stringify(data);

                this.toastr.info('Supplier Invoice Complete: ' + search_results[i].subject_number )


       
                  // Experiment to get the index and change
                // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                // :: Simple and cool way to update the model.
              
              
                let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                search_results[objIndex].RowVersion = "DONE";

                    // end resoponse.
                    console.log('Count: ' + i)
                if(i == (loop_count - 1)){

                    this.getPendingAgentsInvoices();
    
                  this.isShowSpinnerAgentsInvoicesSync = 0;
                  this.toastr.success("We have processed the full action list.")
                 this.clearSearchResults(); // I now clear the array
                }
                      // refreshnumbers\

                      // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                      // // smaller delay if count is less then the maximum -- NEW.
                      // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                      //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                      // }else{
                      // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                      //   }
                      // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                      // setTimeout(() => {  
                      //   this.getPendingClientsInvoicesPayments();
                      //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                      //   this.StartRunIntervalFuntions()
                      // }, set_delay )

          //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                      this.getPendingAgentsInvoices();
    

                },
                err => {
                this.toastr.success('We encounted issues please refer to below,...', err.error);
                        // refreshnumbers\
                        // this.isShowSpinnerClientsInvoicesSync = 0;
                        // this.StartRunIntervalFuntions()
            let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
            search_results[objIndex].RowVersion = "ERROR";
    
                        this.toastr.success('We encounted issues please refer to below,...', err.error);
                        console.error(err);
                        this.response_from_node = JSON.stringify(err);
                        this.response_from_node_raw = err;
                          
                        // Need to set some error varibles
                          this.error_message = err.error.error_message;
                          this.error_message_standard = err.error.error_message_standard;
                          this.error_name = err.error.error_name;
                          this.full_response_data = err.error.full_response_data;
                          this.data_sent = err.error.data_sent;
                          this.data_sent_id = err.error.data_sent.CustomField1.Value;
                          this.data_sent_DisplayID = err.error.data_sent.DisplayID;
                        
                          this.data_sent_client_brand_id = null;
                          this.data_sent_agent_brand_id = null;
                          this.data_sent_invoice_id = err.error.invoice_id;
                          this.data_sent_agent_invoice_id = null;
                        
                          this.full_response_status = err.error.full_response_staus;
                          this.full_response_headers = err.error.full_response_headers;
                          this.full_response = err.error.full_response;
                        
                          
                          // this.getPendingClientsInvoices();

              

                }
                
                );




      console.log ("Block statement execution no." + this.search_results[i].subject_number);       
          // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
          this.toastr.success('Processing');
          // this.toastr.info("Inside")


   await this.delay(10000); // works perfect. for search_results lists
          // await this.delay(15000); // works perfect. (11000)
                // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
             
       


   
       }
      //  this.getPendingClientsInvoicesPayments();
   
    })(); // end async function
      


          // this.getPendingClientsInvoicesPayments();
  
          // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
       
          // this.toastr.success("We have processed the full action list.")
  // this.getPendingAgentsInvoicesPayments()

}



}




// this counld be the new way!!!! YESH...
listAction_addClientInvoicesPaymentsMyob(){
  if (confirm('Are you sure you want push all these invoices Payments to MYOB and update local data? : x' + this.gfunc.set_max_sync_number)) {
    this.isShowSpinnerClientsInvoicesPaymentsSync = 1;
    // let loop_count = 25;
    // let loop_count = this.search_results.length;

      // less than so that it does not automatically loop 20x with no content.
        // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.search_results.length
        // }

        // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.gfunc.set_max_sync_number
        // }

    
    
       
let search_results = [];
search_results = this.search_results; // set as a constant.


    let loop_count = search_results.length;

    (async () => {
      this.isShowSpinnerClientsInvoicesPaymentsSync = 1;
      for (let i = 0; i < loop_count; i++) { // 

let a = i;
    
    //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.



                // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                this.http.post(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA', body, httpOptions)
                .pipe(
                this.toastr.observe({
                  loading: 'Checking... Action: postNewInvoicePayments ...',
                  success: '🚀...',
                  error: '...😡...'
                })
                )
                .pipe(
                retry(0), // you retry 3 times
                delay(1500) // each retry will start after 1 second,
                ).subscribe(
                data => { this.post_new_approved_customer_invoice_payments_result = data;

                let res = data[0];
                // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                this.response_from_node = JSON.stringify(data);

                this.toastr.info('Payment Complete: = ' + search_results[i].subject_number )


       
                  // Experiment to get the index and change
                // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                // :: Simple and cool way to update the model.
                let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                search_results[objIndex].RowVersion = "DONE";

                    // end resoponse.
                    console.log('Count: ' + i)
                if(i == (loop_count - 1)){
    
                  this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                  this.toastr.success("We have processed the full action list.")
                 this.clearSearchResults(); // I now clear the array
                }
                      // refreshnumbers\

                      // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                      // // smaller delay if count is less then the maximum -- NEW.
                      // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                      //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                      // }else{
                      // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                      //   }
                      // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                      // setTimeout(() => {  
                      //   this.getPendingClientsInvoicesPayments();
                      //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                      //   this.StartRunIntervalFuntions()
                      // }, set_delay )

          //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                      this.getPendingClientsInvoicesPayments();
    

                },
                err => {
                this.toastr.success('We encounted issues please refer to below,...', err.error);
                        // refreshnumbers\
                        // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                        // this.StartRunIntervalFuntions()
                        let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                        search_results[objIndex].RowVersion = "ERROR";
                
                console.error(err);
                this.response_from_node = JSON.stringify(err);
                this.response_from_node_raw = err;

                // Need to set some error varibles
                this.error_message = err.error.error_message;
                this.error_message_standard = err.error.error_message_standard;
                this.error_name = err.error.error_name;
                this.full_response_data = err.error.full_response_data;
                this.data_sent = err.error.data_sent;
                this.data_sent_id = err.error.payment_id;
                this.data_sent_DisplayID = err.error.data_sent.customer_UID;

                //Set these up for payments
                this.data_sent_client_brand_id = err.error.customer_UID;
                this.data_sent_agent_brand_id = null;
                this.data_sent_invoice_id = err.error.invoice_UID;
                this.data_sent_invoice_UID = err.error.invoice_UID;
                this.data_sent_client_invoice_id = err.error.invoice_id;
                this.data_sent_agent_invoice_id = null;
                if(this.data_sent_invoice_UID != null){
                this.getSubjectInvoiceByInvoiceByUID(this.data_sent_invoice_UID) // gets the invoice the payment was applied to.

                }
                this.data_sent_invoice_payment_id = err.error.payment_id;
                this.data_sent_work_order_payment_id = null;


                this.full_response_status = err.error.full_response_staus;
                this.full_response_headers = err.error.full_response_headers;
                this.full_response = err.error.full_response;

              

                }
                
                );




      console.log ("Block statement execution no." + this.search_results[i].subject_number);       
          // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
          this.toastr.success('Processing');
          // this.toastr.info("Inside")


   await this.delay(8000); // works perfect. (11000)
          // await this.delay(15000); // works perfect. (11000)
                // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
             
       


   
       }
      //  this.getPendingClientsInvoicesPayments();
   
    })(); // end async function
      


          // this.getPendingClientsInvoicesPayments();
  
          // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
       
          // this.toastr.success("We have processed the full action list.")
  // this.getPendingAgentsInvoicesPayments()

}
}



listAction_addAgentInvoicesPaymentsMyob(){
  if (confirm('Are you sure you want push all these Supplier invoices Payments to MYOB and update local data? : x' + this.gfunc.set_max_sync_number)) {
    this.isShowSpinnerAgentsInvoicesPaymentsSync = 1;
    // let loop_count = 25;
    // let loop_count = this.search_results.length;

      // less than so that it does not automatically loop 20x with no content.
        // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.search_results.length
        // }

        // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
        // loop_count = this.gfunc.set_max_sync_number
        // }

    
    
       
let search_results = [];
search_results = this.search_results; // set as a constant.


    let loop_count = search_results.length;

    (async () => {
      this.isShowSpinnerAgentsInvoicesPaymentsSync = 1;
      for (let i = 0; i < loop_count; i++) { // 

let a = i;
    
    //  this.myobApi_IPTW.setMyobPaymentModelStep1Single(this.search_results[i])  -- original functino that seems to stop at 13 and lloses the payment ID dont use.



                // this.http.get(this.gfunc.sopNodeURL + '/postNewInvoicePayments/fromTSA')
                let body = JSON.stringify(search_results[i]);  // NOT THIS SO AS A CONSTANT
                this.http.post(this.gfunc.sopNodeURL + '/postNewWorkOrderPayments/fromTSA', body, httpOptions)
                .pipe(
                this.toastr.observe({
                  loading: 'Checking... Action: postNewSupplierInvoicePayments ...',
                  success: '🚀...',
                  error: '...😡...'
                })
                )
                .pipe(
                retry(0), // you retry 3 times
                delay(1500) // each retry will start after 1 second,
                ).subscribe(
                data => { this.post_new_approved_supplier_invoice_payments_result = data;

                let res = data[0];
                // console.log('Node Is Saying: " ' + JSON.stringify(res) + ' " ');
                this.response_from_node = JSON.stringify(data);

                this.toastr.info('Payment Complete: = ' + search_results[i].subject_number )


       
                  // Experiment to get the index and change
                // let  objIndex =  search_results.find(someobject => someobject.key == 'subject_number').mark = search_results[i].subject_number
                // ::@ https://stackoverflow.com/questions/4689856/how-to-change-value-of-object-which-is-inside-an-array-using-javascript-or-jquer
                // :: Simple and cool way to update the model.
                let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                search_results[objIndex].RowVersion = "DONE";

                    // end resoponse.
                    console.log('Count: ' + i)
                if(i == (loop_count - 1)){
    
                  this.isShowSpinnerAgentsInvoicesPaymentsSync = 0;
                  this.toastr.success("We have processed the full action list.")
                 this.clearSearchResults(); // I now clear the array
                }
                      // refreshnumbers\

                      // let set_delay; // Added Time based in time taked with max and node app response. // 18000
                      // // smaller delay if count is less then the maximum -- NEW.
                      // if(this.count_pending_clients_invoices_payments <= this.gfunc.set_max_sync_number){
                      //   set_delay = (3500 * this.count_pending_clients_invoices_payments); // Added Time based in time taked with max and node app response. // 18000
                      // }else{
                      // set_delay = (3500 * this.gfunc.set_max_sync_number); // Added Time based in time taked with max and node app response. // 18000
                      //   }
                      // this.toastr.success("This will take approximately: " +  this.millisToMinutesAndSeconds(set_delay)  + " minutes"); 
                      // setTimeout(() => {  
                      //   this.getPendingClientsInvoicesPayments();
                      //   this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                      //   this.StartRunIntervalFuntions()
                      // }, set_delay )

          //  this.deleteSearchResultsItemPaymentID(this.search_results[i].payment_id)    ///  -- mught be stuffin ghis up as well. by reordering oall the time.
                      this.getPendingAgentsInvoicesPayments();
    

                },
                err => {
                this.toastr.success('We encounted issues please refer to below,...', err.error);
                        // refreshnumbers\
                        // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
                        // this.StartRunIntervalFuntions()
                        let  objIndex =  search_results.findIndex(obj => obj.subject_number == search_results[i].subject_number);
                        search_results[objIndex].RowVersion = "ERROR";
                
                console.error(err);
                this.response_from_node = JSON.stringify(err);
                this.response_from_node_raw = err;

                // Need to set some error varibles
                this.error_message = err.error.error_message;
                this.error_message_standard = err.error.error_message_standard;
                this.error_name = err.error.error_name;
                this.full_response_data = err.error.full_response_data;
                this.data_sent = err.error.data_sent;
                this.data_sent_id = err.error.payment_id;
                this.data_sent_DisplayID = err.error.data_sent.customer_UID;

                //Set these up for payments
                this.data_sent_client_brand_id = err.error.customer_UID;
                this.data_sent_agent_brand_id = null;
                this.data_sent_invoice_id = err.error.invoice_UID;
                this.data_sent_invoice_UID = err.error.invoice_UID;
                this.data_sent_client_invoice_id = err.error.invoice_id;
                this.data_sent_agent_invoice_id = null;
                // if(this.data_sent_invoice_UID != null){
                // this.getSubjectInvoiceByInvoiceByUID(this.data_sent_invoice_UID) // gets the invoice the payment was applied to.

                // }
                this.data_sent_invoice_payment_id = err.error.payment_id;
                this.data_sent_work_order_payment_id = null;


                this.full_response_status = err.error.full_response_staus;
                this.full_response_headers = err.error.full_response_headers;
                this.full_response = err.error.full_response;

              

                }
                
                );




      console.log ("Block statement execution no." + this.search_results[i].subject_number);       
          // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
          this.toastr.success('Processing');
          // this.toastr.info("Inside")


   await this.delay(8000); // works perfect. (11000)
          // await this.delay(15000); // works perfect. (11000)
                // this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...???? -- simple function to upldate the or clear payment from search results.
             
       


   
       }
      //  this.getPendingClientsInvoicesPayments();
   
    })(); // end async function
      


          // this.getPendingClientsInvoicesPayments();
  
          // this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
       
          // this.toastr.success("We have processed the full action list.")
  // this.getPendingAgentsInvoicesPayments()

}
}






setMyobPaymentModelStep1Single(payment_data_item){

  (async () => {
 
  
this.myobApi_IPTW.setMyobPaymentModelStep1Single(payment_data_item)
    // this.refreshGrid(); // stop the refresh now that we have check boxes this make the items dissapear and uncheck after process... so do not turn on. feb 2023
    this.toastr.success('Processing');
    await this.delay(10000);

    this.toastr.info("Inside")
    this.getPendingClientsInvoicesPayments();
    this.clearSearchResults(); // This needs to remove or update the Search Results Item specifically form many. -- remove by invoice ID or payment ...????
    this.isShowSpinnerClientsInvoicesPaymentsSync = 0;
    })(); // end async function

    this.toastr.info("All finished")
    this.getPendingClientsInvoicesPayments();
  // this.grid.refresh();
}






deleteSearchResultsItem(key: number) {
  // grid
  // this.toastr.info("clicked remove")
  let data = this.search_results;

let key_order_id = key
// Fitters amd retirms tje 
  this.search_results =  this.search_results.filter(function (order) {
    // return true for salary greater than equals to 25000
    console.log('leaving IDs= ' + data[0]['invoice_id'] + ' != ' + key_order_id);
    return order.invoice_id != data[0]['invoice_id'];
  });
  this.toastr.info("InvoiceID Removed: " + key)
}


deleteSearchResultsItemPaymentID(key: number) {
  // grid
  // this.toastr.info("clicked remove")
  let data = this.search_results;

let key_order_id = key
// Fitters amd retirms tje 
  this.search_results =  this.search_results.filter(function (order) {
    // return true for salary greater than equals to 25000
    console.log('leaving IDs= ' + data[0]['payment_id'] + ' != ' + key_order_id);
    return order.payment_id != data[0]['payment_id'];
  });
  this.toastr.info("InvoicePaymentID Removed: " + key)
}


// Object model.
pushClientInvoicesPaymentsToSearchItems(invoice_payment_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // less than so that it does not automatically loop 20x with no content.
      // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
      // loop_count = this.search_results.length
      // }

      // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

      let loop_count = invoice_payment_model.length
      // if(count){
      //   loop_count = count;
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...invoice_payment_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                invoiceUID: invoice_payment_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Now automatucally runs...Run the Action List Items.
    this.listAction_addClientInvoicesPaymentsMyob();

      // if single




}





pushAgentInvoicesPaymentsToSearchItems(invoice_payment_model, type, count){
  // console.log('Invoice_model' + invoice_model);
  // console.log('Invoice_model JSON' + JSON.stringify(invoice_model));

      // if object

    // loop through sent model (limit to max addedRecords.)
    // let loop_count = 25;
    // less than so that it does not automatically loop 20x with no content.
      // if(this.search_results.length <= this.gfunc.set_max_sync_number && this.search_results.length != null ){
      // loop_count = this.search_results.length
      // }

      // if(this.search_results.length > this.gfunc.set_max_sync_number && this.search_results.length != null ){
      // loop_count = this.gfunc.set_max_sync_number
      // }

      let loop_count = invoice_payment_model.length
      // if(count){
      //   loop_count = count;
      // }

    for (let i = 0; i < loop_count; i++) {


                    // stops duplicates @https://stackoverflow.com/questions/51405712/how-to-prevent-adding-a-duplicate-object-value-of-arraylist
            // if (!this.search_results.some(el => el[i].invoice_id === invoice_model[i].invoice_id)) {}
              this.search_results.push({
                // JSON.stringify(invoice_model)
                ...invoice_payment_model[i], // this little bit of code maps the json objects/models together without having to do it all by hand.
                invoiceUID: invoice_payment_model[i].myob_id // NEW SYNC set this so that I have it for paymet for myob syncs
              });


    }

    // Now automatucally runs...Run the Action List Items.
    this.listAction_addAgentInvoicesPaymentsMyob();

      // if single




}









// delay function
  delay(ms: number) {
    return new Promise( resolve => setTimeout(resolve, ms) );
  }
  


}


